export enum actionTypes {
    SET_TERMS = 'SET_TERMS',
    SET_ALL_PLAYER_TAGS = 'SET_ALL_PLAYER_TAGS',
    SET_URL_TEMPLATES = 'SET_URL_TEMPLATES',
    SET_JUST_REGISTERED = 'SET_JUST_REGISTERED',
    SET_UPDATED_BALANCES = 'SET_UPDATED_BALANCES',
    SET_JUMIO_STATUS = 'SET_JUMIO_STATUS',
    REMOVE_PLAYER_TAG = 'REMOVE_PLAYER_TAG',
    SET_JUMIO_STEP = 'SET_JUMIO_STEP',
    SET_ACTION_AFTER_LOGIN = 'SET_ACTION_AFTER_LOGIN',
    SET_FUTURE_ANTHEMS_GAMES = 'SET_FUTURE_ANTHEMS_GAMES',
    SET_OCCUPATION = 'SET_OCCUPATION',
    SET_IS_SHOW_OCCUPATION_POPUP = 'SET_IS_SHOW_OCCUPATION_POPUP'
}

export enum PLAYER_TAG_TYPES {
    SIMPLE = 'simple',
    TEXT = 'text',
    NUMBER = 'number',
    DATE = 'date',
    DELTA = 'delta'
}
